import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";

/**
 * DynamicPage — renders a Mongo-stored, rich-text CMS page.
 * Route hooked via /about, /contact, or /page/:slug
 */
export default function DynamicPage({ fixedSlug }) {
  const params = useParams();
  const slug = fixedSlug || params.slug;
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    window.scrollTo({ top: 0, behavior: "auto" });
    api.get(`/pages/${slug}`)
      .then(r => setPage(r.data))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-slate-500" data-testid="page-loading">Loading…</div>;
  if (notFound || !page) return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center" data-testid="page-not-found">
      <h1 className="font-editorial text-3xl font-bold mb-2">Page not found</h1>
      <p className="text-slate-500">The page you are looking for does not exist.</p>
    </div>
  );

  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-testid={`page-${page.slug}`}>
      <h1 className="headline text-3xl md:text-5xl font-bold text-slate-900 mb-8" data-testid="page-title">{page.title}</h1>
      <div
        className="prose-editorial text-slate-800"
        dangerouslySetInnerHTML={{ __html: (page.content_html || "").replace(/&nbsp;/g, " ").replace(/\u00A0/g, " ") }}
        data-testid="page-content"
      />
    </article>
  );
}
